import { makePieActionObjs } from 'shared/imports/pieActionGenerators'
import { prependAppName } from 'shared/imports/sharedHelperFunctions'

export const controlPanelAppName = '@@dlc-2-control-panel/'

const createNewPDFEmailObjs = makePieActionObjs('create', 'NewPDFEmail')
export const createNewPDFEmailTypes = prependAppName(controlPanelAppName, createNewPDFEmailObjs.pieDict)

export const actionTypes = {
    EXIT_EDITOR: `${controlPanelAppName}EXIT_EDITOR`,
    RESET_EDITABLE_ELEMENT_DETAILS: `${controlPanelAppName}RESET_EDITABLE_ELEMENT_DETAILS`,
    SET_BULK_DOWNLOAD_FILE_NAME: `${controlPanelAppName}SET_BULK_DOWNLOAD_FILE_NAME`,
    REMOVE_ELEMENT: `${controlPanelAppName}REMOVE_ELEMENT`,
    REMOVE_SINGLE_CONNECTING_COMPONENT: `${controlPanelAppName}REMOVE_SINGLE_CONNECTING_COMPONENT`,
    REMOVE_CONNECTING_COMPONENT_KEY: `${controlPanelAppName}REMOVE_CONNECTING_COMPONENT_KEY`,
    SAVE_EDITOR_TEMP_STATE: `${controlPanelAppName}SAVE_EDITOR_TEMP_STATE`,
    REMOVE_EMPTY_STATE_ELEMENT: `${controlPanelAppName}REMOVE_EMPTY_STATE_ELEMENT`
}

export default actionTypes
